import RoboFriends from './img/RoboFriends.png';
import TodoList from './img/TodoList.png';
import ReactWeb from './img/ReactWeb.png';
import GetUserProject from './img/GetUserProject.png';
import BackgroundGenerator from './img/BackgroundGenerator.png';
import CalculatorScript from './img/CalculatorScript.png';

export const products = [
    {
        id: 1,
        img: RoboFriends,
        link: "https://github.com/HardikJain40153/robofriends",
    },
    {
        id: 2,
        img: ReactWeb,
        link: "https://github.com/HardikJain40153/reactweb",
    },
    {
        id: 3,
        img: TodoList,
        link: "https://github.com/HardikJain40153/ToDO-List",
    },
    {
        id: 4,
        img: BackgroundGenerator,
        link: "https://github.com/HardikJain40153/background-generator",
    },
    {
        id: 5,
        img: GetUserProject,
        link: "https://github.com/HardikJain40153/Get-User-Project",
    },
    {
        id: 6,
        img: CalculatorScript,
        link: "https://github.com/HardikJain40153/CalculatorScript",
    },
];